import ClientsPage from "@pages/ClientsPage/ClientsPage"
import { useAppStructure } from "@redux/features/appStructure/useAppStructure"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_adminPageLayout/clients/")({
	component: RouteComponent,
})

function RouteComponent() {
	const { data: appStruct } = useAppStructure()

	return appStruct == null ? <>{"Loading..."}</> : <ClientsPage />
}
